
import Vue from "vue";
import { mapFields } from "vuex-map-fields";
import { showComponentMixin } from "@/utils/mixins";
import { VilkenSituation } from "@/store/types";
import { VilkenSituationText, UnderrattelseskyldighetText } from "@/store/map";
import SammanstallningField from "@/components/Kontaktuppgifter/SammanstallningField.vue";
import MedvetetFelForetagSammanstallning from "@/components/Observationer/MedvetetFelForetagSammanstallning.vue";
import MedvetetFelPrivatpersonSammanstallning from "@/components/Observationer/MedvetetFelPrivatpersonSammanstallning.vue";
import AnstalldSammanstallning from "@/components/Observationer/AnstalldSammanstallning.vue";
import SammanboendeSammanstallning from "@/components/Observationer/SammanboendeSammanstallning.vue";
import UtomlandsSammanstallning from "@/components/Observationer/UtomlandsSammanstallning.vue";
import FelaktigAssistansSammanstallning from "@/components/Observationer/FelaktigAssistansSammanstallning.vue";
import StatligtTandvardsstodSammanstallning from "@/components/Observationer/StatligtTandvardsstodSammanstallning.vue";
import AnnatPrivatpersonSammanstallning from "@/components/Observationer/AnnatPrivatpersonSammanstallning.vue";
import AnnatForetagSammanstallning from "@/components/Observationer/AnnatForetagSammanstallning.vue";
import UppladdadeFilerSammanstallning from "@/components/Observationer/UppladdadeFilerSammanstallning.vue";

export default Vue.extend({
    name: "FkObservationerSammanfattning",
    components: {
        AnnatForetagSammanstallning,
        AnnatPrivatpersonSammanstallning,
        AnstalldSammanstallning,
        FelaktigAssistansSammanstallning,
        MedvetetFelForetagSammanstallning,
        MedvetetFelPrivatpersonSammanstallning,
        SammanboendeSammanstallning,
        SammanstallningField,
        StatligtTandvardsstodSammanstallning,
        UppladdadeFilerSammanstallning,
        UtomlandsSammanstallning,
    },
    mixins: [showComponentMixin],
    data: () => ({
        VilkenSituation,
        VilkenSituationText,
        UnderrattelseskyldighetText,
    }),
    computed: {
        ...mapFields([
            "observationer.files",
            "observationer.situation",
            "observationer.underrattelseskyldighet",
            "observationer.typAvErsattning",
        ]),
    },
});
